<!-- =========================================================================================
  File Name: Subscription.vue
  Description: Subscription page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list" class="vx-card p-6">

    <!-- Title and Buttons Action -->
    <div class="text-title">
      <span></span>
    </div>
    <vs-row class="pl-2">
      <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="12">
        <vs-button color="success" icon="person_add" @click="setUpCreate">登録</vs-button>
      </vs-col>
    </vs-row>

    <vs-popup id="dialogDelecd te" title="サブスクライブ削除" :active.sync="activeDelete" button-close-hidden>
      <div>
          <span>
            選択したサブスクライブを削除しますか？
          </span>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>
        <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
      </div>
    </vs-popup>

    <!-- Create and Edit Dialog -->
    <vs-popup id="dialogUpdate" :title="title" :active.sync="activePopup" button-close-hidden>
      <div>
        <div>
          <vx-card title="サブスクライブ詳細"
                   card-background ="rgb(240, 238, 241)"
                   height="420px"
                   class="pb-2"
                   style="font-size: 12px">
            <div>
              <vs-row>
                <vs-col class="flex items-center" vs-w="3">
                  <span>サブスクライブ名<span style="color: red">*</span></span>
                </vs-col>
                <vs-col vs-w="9">
                  <vs-row>
                    <vs-input v-validate.immediate="'required'" maxlength="256" name="サブスクライブ名" v-model="subscription_name" class="w-full mb-2"/>
                  </vs-row>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-offset="3">
                  <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("サブスクライブ名") | convertError }}</span>
                </vs-col>
              </vs-row>
            </div>
          </vx-card>
        </div>
        <div style="display: flex; justify-content: flex-end" class="pt-4">
          <vs-button v-if="title != 'サブスクライブ情報更新'" @click="actionCreate" :disabled="!validateForm && submited" icon="person_add" color="success" style="padding: 8px; margin-right: 5px;height: 37px">登録</vs-button>
          <vs-button v-else @click="actionUpdate" :disabled="!validateForm" icon="assignment" color="success" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
          <vs-button @click="activePopup = false" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- AgGrid Table -->
    <ag-grid-vue
        id="myGrid"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table database"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="subscriptionData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :domLayout="domLayout"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
        @sortChanged="onSortChangedEvent"
        :overlayNoRowsTemplate="noRowsTemplate"
        :detailRowAutoHeight="true"
    >
    </ag-grid-vue>

    <div style="position: relative">
      <!-- ITEMS PER PAGE -->
      <div>
        <div class="flex items-center justify-between">
          <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
        </div>
      </div>
      <!-- pagination -->
      <vs-pagination
          :total="totalPages"
          v-model="currentPage"
          :max="0"
          class="pr-10 pt-10"
      />
    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect       from 'vue-select'
import EventBus      from '../../../EventBus'
import {mapActions, mapGetters} from 'vuex'

// Cell Renderer
import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererActions
  },
  data () {
    return {
      activePopup:     false,
      activeDelete:    false,
      submited:        false,
      title:           '',
      id:              null,
      ids:             [],
      subscription_id:         null,
      subscription_name:      null,

      paginationOptions: [
        10, 20, 30, 50
      ],

      //SortServer
      orderBy: 'id',
      orderDir: 'asc',

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          width: 35,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'サブスクライブ名',
          field: 'name',
          filter: true,
          width: 220,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '',
          field: 'transactions',
          width: 150,
          cellRendererFramework: 'CellRendererActions',
          unSortIcon: false,
          suppressMovable: true,
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions
      }
    }
  },
  watch: {
    paginationPageSize(val){
      this.setPagination(val);
    }
  },
  computed: {
    ...mapGetters({
       getSubscription: 'getSubscription'
    }),
    validateForm(){
      return !this.errors.any()
    },
    subscriptionData () {
      let subscriptionData = []
      this.$store.state.subscriptions.subscriptions.forEach((element) => {
        subscriptionData.push(Object.assign(element));
      });
      return subscriptionData
    },
    totalPages () {
      return parseInt(this.$store.state.subscriptions.infoDB.totalPage)
    },
    totalRow(){
      return parseInt(this.$store.state.subscriptions.infoDB.totalRow)
    },
    currentPage: {
      get () {
        return this.pageNumber
      },
      async set (val) {
        this.pageNumber = val
        await this.searchSubscriptionWithOrder();
        this.ids = []
        this.gridApi.paginationGoToPage(val-1)
      }
    }
  },
  methods: {
    ...mapActions({
      addSubscriptions:        'subscriptions/addSubscriptions',
      updateSubscriptions:     'subscriptions/updateSubscriptions',
      showSubscriptions:      'subscriptions/showSubscriptions',
      fetchSubscriptions:     'subscriptions/fetchSubscriptions',
      removeSubscriptions:  'subscriptions/removeSubscriptions'
    }),
    onSelectionChanged() {
      this.ids = this.gridApi.getSelectedRows().map(subscription => subscription.id)
    },
    onSortChangedEvent(event){
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function(column){
        if (column.getSort()){
          root.orderDir = column.getSort()
          root.orderBy  = column.getColId()
          root.searchSubscriptionWithOrder();
          return;
        }
      });
    },
    searchSubscriptionWithOrder(){
      this.fetchSubscriptions({orderBy: this.orderBy, orderDir: this.orderDir, limit: this.paginationPageSize, page: this.pageNumber})
    },
    setUpCreate(){
      // clear all fields before create
          this.id               = null,
          this.subscription_id          = null,
          this.subscription_name       = null,
          this.submited         = false,
          this.title            = 'サブスクライブ情報登録'
      this.activePopup      = true
    },
    async actionCreate(){
      if(!this.validateForm){
        this.submited = true; // first: no show error => after submited: show error
      }
      else{
        let subscription = {
          name:     this.subscription_name
        }
        await this.addSubscriptions(subscription)
        this.activePopup = false
        await this.searchSubscriptionWithOrder()
      }
    },
    async actionUpdate(){
      await this.updateSubscriptions(
          {
            id:             this.id,
            name:     this.subscription_name
          })
      this.activePopup = false
      this.ids = []
      await this.searchSubscriptionWithOrder()
    },
    async confirmDelete(){
      await this.deleteSelect();
      this.activeDelete = false
      this.activePopup = false
    },
    async deleteSelect () {
      await this.removeSubscriptions(this.ids)
      this.gridApi.deselectAll()
      this.ids = null
      await this.searchSubscriptionWithOrder()
    },
    async setPagination(val){
      this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1
      await this.searchSubscriptionWithOrder();
      this.ids = []
    },
    editListener(id){
      this.showSubscriptions(id)
          .then(subscription => {
            this.id           = subscription.id
            this.subscription_name   = subscription.name
            this.title        = 'サブスクライブ情報更新'
            this.submited     = true
            this.activePopup  = true
          })
    },
    deleteListener (id){
      this.activeDelete = true
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    EventBus.$on('editRecord', this.editListener)
    EventBus.$on('deleteRecord', this.deleteListener);
    // save paginationSize to sessionStorage (when fresh browser)
    const root = this
    window.addEventListener('beforeunload', function(){
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
    })
  },
  async created () {
    await this.searchSubscriptionWithOrder();
  },
  beforeMount(){
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
  },
  updated(){
    // set paginationPageSize = 10 (default) when change page/route
    sessionStorage.setItem("paginationPageSize", 10)
    // calc number startRow and endRow
    this.$nextTick(()=>{
      if(!this.$store.state.loading && this.subscriptionData.length > 0){
        this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
        if(this.subscriptionData.length == this.paginationPageSize) this.endRow = this.pageNumber*this.paginationPageSize
        else this.endRow = this.paginationPageSize*this.pageNumber + this.subscriptionData.length - this.paginationPageSize
      }
      if(this.subscriptionData.length == 0){
        this.endRow = 0
        this.startRow = 0
      }
    });
  },
  beforeDestroy(){
    EventBus.$off('editRecord', this.editListener);
    EventBus.$off('deleteRecord', this.deleteListener);
  },
  destroyed(){
    // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
    document.getElementById('dialogDelete').style.display = 'none'
    document.getElementById('dialogUpdate').style.display = 'none'
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/kinds.scss"
</style>
